import { useState, useEffect } from 'react';

export const useTimelineDrag = (lineRef: React.RefObject<HTMLDivElement>, setProgressInThreeJS: (progress: number) => void) => {
  const [isDragging, setIsDragging] = useState(false);

  const updateDotPosition = (e: MouseEvent | React.MouseEvent) => {
    if (!lineRef.current) return;

    const line = lineRef.current;
    const rect = line.getBoundingClientRect();
    
    let newPosition = ((e.clientX - rect.left) / rect.width) * 100;
    newPosition = Math.max(0, Math.min(100, newPosition));
    
    setProgressInThreeJS(newPosition / 100);
  };

  const handleMouseDown = (e: React.MouseEvent) => {
    setIsDragging(true);
    updateDotPosition(e);
  };

  const handleMouseMove = (e: MouseEvent) => {
    if (!isDragging) return;
    updateDotPosition(e);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    if (isDragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);

  return {
    isDragging,
    handleMouseDown
  };
}; 